import { Icon as LucideIcon } from 'lucide-react';
import { Icon } from '../Icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const iconNode = [['path', {
  d: 'M11.1 17.3h7.7',
  key: '1aaanr'
}], ['path', {
  d: 'M11.1 6.7h7.7',
  key: '1wxmiy'
}], ['circle', {
  cx: '6.7',
  cy: '17.3',
  r: '1.4',
  key: 'byrzu5'
}], ['circle', {
  cx: '6.7',
  cy: '6.7',
  r: '1.4',
  key: '1y0wdq'
}], ['rect', {
  x: '1.5',
  y: '1.4',
  width: '21.2',
  height: '10.6',
  rx: '2',
  key: '18rjr0'
}], ['rect', {
  x: '1.5',
  y: '12',
  width: '21.2',
  height: '10.6',
  rx: '2',
  key: '8nljh8'
}]];
export function ProductCloud() {
  return /*#__PURE__*/_jsx(Icon, {
    icon: LucideIcon,
    iconNode: iconNode,
    className: "lucide-custom-product-cloud"
  });
}